import React from 'react';

const About = () => {
  return (
    <div className="container py-5">
      <div className="row justify-content-center">
        <div className="col-lg-8 col-md-10">
          <div className="glass-card">
            <h1 className="commercial-heading mb-4">About VowAuthor</h1>
            
            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Our Mission</h2>
              <p style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                At VowAuthor, we believe that every love story deserves to be told in the most beautiful way possible. 
                Your wedding day is one of the most important moments of your life, and your vows should perfectly 
                capture the depth of your love and commitment. Our mission is to help couples express their feelings 
                with eloquence and heart.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">What We Do</h2>
              <p style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                VowAuthor uses thoughtful AI technology to help you create personalized, beautiful wedding vows in minutes. 
                Simply share your love story—how you met, what you cherish about your partner, and the promises you want 
                to make—and we'll craft vows that will move hearts and bring tears of joy.
              </p>
              <p style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                Our service is designed to be:
              </p>
              <ul style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginLeft: '2rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                <li><strong>Personal:</strong> Every set of vows is unique to your relationship and story</li>
                <li><strong>Affordable:</strong> At just $9.99 for up to 5 vow generations, perfect for both partners</li>
                <li><strong>Convenient:</strong> Create vows from anywhere, on your own schedule</li>
                <li><strong>Beautiful:</strong> Elegantly formatted, ready to print or read from</li>
                <li><strong>Flexible:</strong> Codes never expire, generate as many versions as you need</li>
              </ul>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Why Choose VowAuthor?</h2>
              <p style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                Writing your own vows can be daunting. You want to express everything in your heart, but finding the 
                right words isn't always easy. Professional vow writers can charge hundreds of dollars, and generic 
                templates don't capture what makes your love special. VowAuthor bridges this gap—giving you 
                professionally crafted, deeply personal vows at an accessible price.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Perfect for Every Couple</h2>
              <p style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                Whether you're looking for traditional and romantic vows, modern and playful promises, or something 
                with spiritual meaning, VowAuthor adapts to your style. We celebrate all love stories and are proud 
                to help couples from all backgrounds express their commitment.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Our Promise to You</h2>
              <p style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                We understand how important your wedding day is. That's why we offer a satisfaction guarantee—if you're 
                not happy with your vows, we'll regenerate them for free. Your love deserves to be celebrated with 
                words that truly resonate.
              </p>
            </div>

            <div className="mb-4">
              <h2 className="commercial-subheading mb-3">Contact Us</h2>
              <p style={{ color: '#5d3a3b', lineHeight: '1.8', fontSize: '1.1rem', marginBottom: '1.5rem', fontFamily: "'Lora', serif" }}>
                Questions about our service? Need help with your order? Please don't hesitate to{' '}
                <a href="/help" style={{ color: '#1e3a5f', textDecoration: 'underline' }}>contact our support team</a>. 
                We're here to help make your special day perfect.
              </p>
            </div>

            <div className="text-center mt-5">
              <a href="/" className="btn btn-primary btn-lg">
                <i className="bi bi-heart-fill me-2"></i>
                Start Writing Your Vows
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default About;
